import moment from 'moment';
import statuses, {
    renewalStatuses,
    subscriptionStatuses,
    subscriptionTypes,
} from '../../../constants/statuses';
import paymentSources from '../../../constants/paymentSources';

const getSubscriptionStatuses = (status) => {
    const [subscriptionStatus, subscriptionType, renewalStatus] = status.split('_');
    return { subscriptionStatus, subscriptionType, renewalStatus };
};

const getSubscriptionStatus = ({ status }) => getSubscriptionStatuses(status).subscriptionStatus || '';
const getSubscriptionType = ({ status }) => getSubscriptionStatuses(status).subscriptionType || '';
const getRenewalStatus = ({ status }) => getSubscriptionStatuses(status).renewalStatus || '';
const getSubscriptionDisabledActions = ({ disabledActions }) => disabledActions || [];

/**
 * Subscription helpers
 */
export const isActive = subscription => getSubscriptionStatus(subscription) === subscriptionStatuses.ACTIVE;

export const isInactive = subscription => getSubscriptionStatus(subscription) === subscriptionStatuses.INACTIVE;

export const isTermed = subscription => getSubscriptionType(subscription).includes(subscriptionTypes.TERMED);

export const isCanceled = subscription => getRenewalStatus(subscription).includes(renewalStatuses.CANCELED);

export const isDiscontinued = subscription => getRenewalStatus(subscription).includes(renewalStatuses.DISCONTINUED);

export const isExpired = subscription => getSubscriptionStatus(subscription).includes(subscriptionStatuses.EXPIRED);

export const isEmpty = subscription => getSubscriptionStatus(subscription).includes(statuses.EMPTY);

export const isFree = subscription => subscription?.payment?.nextBilling?.lackReason === 'Free';

/**
 * Subscription actions helpers
 */

export const isActionDisabled = actionType => subscription => getSubscriptionDisabledActions(subscription)
    .some(disabledAction => disabledAction.type === actionType);

/**
 * Payment helpers
 */
export const isPaymentNonInstant = ({ payment = {} }) => payment.nonInstant;

export const isPaymentSourceITunes = ({ payment = {} }) =>
    payment?.source?.toUpperCase() === paymentSources.ITUNES;

export const isPaymentSourceTelenor = ({ payment = {} }) =>
    payment?.source?.toUpperCase() === paymentSources.TELENOR;

export const isPaymentTypeCreditCard = ({ payment = {} }) =>
    ['VISA', 'MC', 'MASTERCARD'].includes(payment.type);

export const isPaymentExpired = ({ payment = {} }) =>
    payment.expiryDate && moment(payment.expiryDate).diff(moment()) < 0;
